import { useState } from 'react';
import { SEO, breadcrumbSchema } from '../components/SEO';
import { STATIC_SEO } from '../data/seoConfig';
import PageHero from '../components/PageHero';
import CTASection from '../components/CTASection';
import { BlogCard } from '../components/cards';
import { Stagger, StaggerItem } from '../components/Reveal';
import { POSTS } from '../data/blog';
import { IMAGES } from '../data/site';

const BlogPage = () => {
  const categories = ['All', ...new Set(POSTS.map((p) => p.category))];
  const [active, setActive] = useState('All');
  const posts = active === 'All' ? POSTS : POSTS.filter((p) => p.category === active);

  return (
    <>
      <SEO
        title={STATIC_SEO.blog.title}
        description={STATIC_SEO.blog.description}
        path="/blog/"
        jsonLd={[breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Blog', path: '/blog/' }])]}
      />
      <PageHero
        overline="The Journal"
        title="Outdoor living insights, written for Nebraska"
        intro="Expert tips, design inspiration, and honest planning guides for creating your dream outdoor living space — from a team that's been building them for 22+ years."
        image={IMAGES.pergola}
        breadcrumbs={[{ name: 'Home', path: '/' }, { name: 'Blog' }]}
      />
      <section className="py-20 md:py-28">
        <div className="container-site">
          <div className="mb-12 flex flex-wrap gap-2" role="tablist" aria-label="Filter articles by category">
            {categories.map((c) => (
              <button
                key={c}
                data-testid={`blog-filter-${c.replace(/[^a-z]/gi, '-').toLowerCase()}`}
                onClick={() => setActive(c)}
                aria-pressed={active === c}
                className={`border px-4 py-2 text-xs font-semibold uppercase tracking-[0.15em] transition-colors ${
                  active === c ? 'border-bronze bg-bronze text-paper' : 'border-line text-muted2 hover:border-bronze hover:text-bronze'
                }`}
              >
                {c}
              </button>
            ))}
          </div>
          <Stagger className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {posts.map((p) => <StaggerItem key={p.slug}><BlogCard post={p} /></StaggerItem>)}
          </Stagger>
        </div>
      </section>
      <CTASection title="Inspired? Let's talk about your backyard" text="Every article here comes from real project experience. Bring us your ideas — the consultation is free." testId="blog-cta" />
    </>
  );
};

export default BlogPage;
